import { Button } from "@/components/ui/button"
import { useNapForm } from "../NapFormContext"

interface SleepDebtStepProps {
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function SleepDebtStep({ childName, onNext, onPrev }: SleepDebtStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center">
        Did {childName || 'your baby'} seem overtired?
      </h3>
      <div className="grid grid-cols-2 gap-3 max-w-[240px] mx-auto">
        <Button
          type="button"
          variant={form.watch("signs_of_sleep_debt") ? "default" : "outline"}
          className="w-full py-3 h-auto hover:bg-accent/50"
          onClick={() => {
            form.setValue("signs_of_sleep_debt", true)
            onNext()
          }}
        >
          Yes
        </Button>
        <Button
          type="button"
          variant={form.watch("signs_of_sleep_debt") === false ? "default" : "outline"}
          className="w-full py-3 h-auto hover:bg-accent/50"
          onClick={() => {
            form.setValue("signs_of_sleep_debt", false)
            onNext()
          }}
        >
          No
        </Button>
      </div>
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
      </div>
    </div>
  )
}